const experience = [
  {
    role: "Software Engineer Intern",
    organization: "Paperbill Tech Pvt. Ltd.",
    type: "Internship",
    period: "July 2025 — Oct 2025",
    summary: "Contributed to a live billing application across feature delivery, Java API integration, database performance, and release testing.",
    highlights: [
      "Delivered 5–6 production features, contributing from requirements analysis through testing, deployment, and post-release monitoring.",
      "Optimized slow MySQL queries with indexing and query restructuring, reducing execution time by approximately 25%.",
      "Integrated frontend components with Java APIs and resolved issues in production billing workflows.",
      "Performed functional, regression, and integration testing; participated in Agile sprints, code reviews, and Git-based collaboration."
    ],
    focus: ["Java APIs", "MySQL optimization", "Production features", "Testing and release"]
  },
  {
    role: "Freelance Software Developer",
    organization: "PhysioWaye",
    type: "Client project",
    period: "Aug 2025 — Sept 2026",
    summary: "Delivered a live physiotherapy e-commerce platform and strengthened its backend delivery with documented APIs and automated quality checks.",
    highlights: [
      "Built customer-facing commerce and supporting backend workflows for product discovery, checkout, payments, and orders.",
      "Documented 30+ versioned REST APIs across authentication, product, order, payment, and inventory workflows using Swagger/OpenAPI.",
      "Configured GitHub Actions CI/CD with ESLint and Jest test gates to automate code-quality checks.",
      "Implemented secure customer and admin workflows using JWT, role-based access, and PostgreSQL Row Level Security."
    ],
    focus: ["REST API documentation", "CI/CD", "Node.js", "PostgreSQL"],
    link: "https://www.physiowaye.com",
    linkLabel: "View live platform"
  }
];

export default experience;
